import type { ResourceMember } from './types'

/** Returns the string used to identify a resource member in the UI. */
export const getResourceMemberDisplayName = (member: ResourceMember): string => {
  if (member.fullName) {
    return member.fullName
  }

  const name = [member.firstName, member.lastName].filter(Boolean).join(' ')

  return name || member.email || member.id
}
